import { DATE_DAY_FORMATE } from "@/libs/constants";
import moment from "moment";
export function commonValidateRule(text, extral = []) {
  return (val) => {
    return !extral.concat(["", undefined, null]).includes(val) || text;
  };
}

export function isIllegalityValue(val) {
  return ["", null, undefined].includes(val);
}
export function creatBcParams() {
  return {
    //  advertise_account_id: null, 下一期
    recharge_type: "", // 充值类型
    recharge_amount: null,
    consumption_mode: null,
    refundable: false,
  };
}
export function createTeam() {
  return {
    id: null, // 团队 费用id
    team_id: null, // 团队id
    price: null, // 团队金额
    desc: null, // 备注
  };
}
export function createSpu() {
  return {
    id: null,
    cya_spu_id: null, // spu id
    amount: null, // 团队金额
    desc: null, // 备注
  }
}

export function createFTinfor() {
  return {
    id: null,
    name: null, // 费用项名称
    price: null, // 费用金额
    expense_type_id: null, // 费用类型 id
    // invoice_price: null, // 发票金额
    invoice_type: null, // 发票类型
    tax: null, // 税额
    tax_rate: null, // 税率
    desc: null, // 备注
    expense_nature_id: null, // 费用 nature id
    customer_function_id: null, // 职能 id
    customer_type: null, // 员工类型
    item_type_id: null, // 产品类型 id
    fund_usage_id: null, // 资金用途 id
    account_title_id: null, // 会计科目 id
    analysis_title_id: null, // 分析科目 id
    expense_teams: [createTeam()],
    expense_spus: [createSpu()]
  };
}

export function createFKParams() {
  return {
    id: null,
    payment_type: 1, // 付款申请单
    statement_item_ids: null, // 从流水过来的要带这个字段
    zhibiao_date: moment().format(DATE_DAY_FORMATE), // 制表时间 （后端不需要）,
    is_cbs: false, // 是否是
    cbs_remark: null, // 业务摘要
    is_open_contract: false, // 是否是开口合同（后端不需要）
    contract_company_id: null, // 合同公司（后端不需要）
    contract_payee_company_id: null, // 合同收款对象（后端不需要）
    is_jianyi: false, // 是否是简易填写（后端不需要）
    can_change_jy: true, // 能否编辑填写类型（后端不需要）
    fill_user: null, // 制单人（后端不需要）
    is_financer: false, // 是否是财务（后端不需要）
    contract_nature: null, // 合同属性（后端不需要）
    is_recharge: false, // 是否是充值合同（后端不需要）
    hetong_total_price: null, // 合同总金额(后端不需要)
    have_paid: null, // 合同已付金额 （后端不需要）
    contract_invoices: [], // 合同带出的发票信息（后端不需要）
    sk_company_id: null, // 收款账户公司id （后端不需要） 收款账户与公司id是强绑定的 当公司id发生了变化 需要清空收款账号
    purpose: null, // 兼职外包付款-实际交付内容
    apply_user: null,
    apply_user_id: null,
    uid: null, // 单据编号
    name: null, // 单据名称
    company_id: null, // 公司
    team_id: null, // 团队
    contract_id: null, // 关联合同
    outsource_contract_id: null, // 关联兼职外包合同
    payee_account_name: null, // 收款账户名称
    payee_company_account_id: null, // 收款账户
    payee_bank: null, //
    payee_bank_number: null,
    payee_company_id: null,
    payee_company: null,
    payee_user_id: null,
    payee_user: null,
    verified_at: null, // 入账会计期
    paid_at: null, // 付款日期
    kind: null, // 兼职外包平台
    expense_payment_bank_id: null, //  付款银行 id
    payment_bank_name: null, //  付款银行名称
    payment_bank_account: null, //  付款银行账户名
    payment_bank_number: null, // 付款银行卡号（账号）
    payment_purpose: null, // 付款类型
    cny_total_price: null, // 人民币总金额
    total_price: null, // 总金额
    is_simple: false, // 是否是建议付款
    can_cross_company: false, // 是否是夸公司付款
    desc: null, // 单据备注
    currency: "CNY", // 币别
    expense_group_settlements: [], // 付款批次 contract_settlement_id payment_amount
    expense_group_recharge: creatBcParams(), // 充值信息
    expenses: [createFTinfor()],
    bfiles: [],
    // ads_record_ids: null,
    // ads_vas_record_ids: null,
    have_to_select_tf: false, //是否必须要有投放记录
    tfjc_type: 0, // 0:投放记录；1:加成服务
    placing_ads_records: [], // 投放记录
    placing_ads_vas_records: [], // 加成服务
    contract_source: {},
    placing_ads_records_sum: 0, // 投放记录与加成服务本次付款金额
  };
}

export function setHaveToSelect(contract) {
  contract = contract || {};
  contract.contract_type = contract.contract_type || {};
  return (
    contract.contract_nature === "close" &&
    !contract.is_recharge &&
    contract.contract_type.sub_type === "广告合同"
  );
}

export function canGenerateAds(target) {
  target = target || {};
  return (
    target.contract_type &&
    target.contract_type.sub_type === "广告合同" &&
    target.contract_nature === "close" &&
    !target.is_recharge
  );
}

export function handleParams(params) {
  // eslint-disable-next-line
  const {
    zhibiao_date,
    contract_nature,
    can_change_jy,
    fill_user,
    is_open_contract,
    have_paid,
    sk_company_id,
    is_period_closed,
    is_cbs,
    tfjc_type,
    placing_ads_records_sum,
    is_jianyi,
    is_financer,
    is_recharge,
    ...other_params
  } = params;
  if (!is_cbs) {
    delete other_params.cbs_remark;
  }
  // 合同结算款项 合同属性是闭口合同
  if (
    contract_nature === "close" &&
    other_params.expense_group_settlements.length
  ) {
    other_params.expense_group_settlements = other_params.expense_group_settlements.map(
      ({ contract_settlement_id, payment_amount }) => {
        return {
          contract_settlement_id,
          payment_amount,
        };
      }
    );
  } else {
    delete other_params.expense_group_settlements;
  }

  if (other_params.payment_purpose === "outsource") {
    delete other_params.contract_id;
  } else {
    delete other_params.outsource_contract_id;
    delete other_params.purpose;
  }
  // 如果是在不是云账户或者cbs
  // if (!is_yzh_cbs) {
  //     other_params.is_simple = true
  // }
  // 是否充值信息
  if (!is_recharge) {
    delete other_params.expense_group_recharge;
  }

  // 是否是简易填写
  if (is_jianyi) {
    // 避免在简易填写的情况下，自动填写的内容被覆盖
    if (
      !other_params.expenses ||
      !Array.isArray(other_params.expenses) ||
      other_params.expenses.length === 0
    ) {
      other_params.expenses = [createFTinfor()];
    }
    const expenses_1 = other_params.expenses[0];
    expenses_1.name = other_params.name;
    expenses_1.price = other_params.total_price;
    expenses_1.expense_teams[0].team_id = other_params.team_id;
    expenses_1.expense_teams[0].price = other_params.total_price;
  }
  // 投放记录
  // if (other_params.ads_record_ids && other_params.ads_record_ids.length) {
  //     other_params.ads_record_ids = other_params.ads_record_ids.map(i => i.id)
  // } else {
  //     delete other_params.ads_record_ids
  // }
  // 加成服务
  // if (other_params.ads_vas_record_ids && other_params.ads_vas_record_ids.length) {
  //     other_params.ads_vas_record_ids = other_params.ads_vas_record_ids.map(i => i.id)
  // } else {
  //     delete other_params.ads_vas_record_ids
  // }
  other_params.expenses.forEach((expense) => {
    delete expense.is_insider_trading; // 组件带出的脏数据
  });
  if (!is_financer) {
    delete other_params.cny_total_price;
  }
  other_params.placing_ads_records = other_params.placing_ads_records || [];
  other_params.placing_ads_records = other_params.placing_ads_records
    .filter((i) => !!i.id)
    .map((i) => ({
      id: i.id,
      have_paid_amount: i.have_paid_amount,
    }));
  other_params.placing_ads_vas_records =
    other_params.placing_ads_vas_records || [];
  other_params.placing_ads_vas_records = other_params.placing_ads_vas_records
    .filter((i) => !!i.id)
    .map((i) => ({
      id: i.id,
      have_paid_amount: i.have_paid_amount,
    }));
  // if (tfjc_type === 0) {
  //     delete other_params.placing_ads_vas_records
  //     other_params.placing_ads_records = other_params.placing_ads_records || []
  //     other_params.placing_ads_records = other_params.placing_ads_records.filter(i => !!i.id).map(i => ({
  //         id:i.id,
  //         have_paid_amount:i.have_paid_amount
  //     }))
  // } else {
  //     delete other_params.placing_ads_records
  //     other_params.placing_ads_vas_records = other_params.placing_ads_vas_records || []
  //     other_params.placing_ads_vas_records = other_params.placing_ads_vas_records.filter(i => !!i.id).map(i => ({
  //         id:i.id,
  //         have_paid_amount:i.have_paid_amount
  //     }))
  // }
  return other_params;
}

export function handleEditParams(res) {
  const params_stand = createFKParams();
  const params = {};
  Object.keys(params_stand).forEach((key) => {
    switch (key) {
      // this.params.fill_user = this.params.apply_user
      /* 前端对数据清理 */
      case "fill_user":
        params[key] = res.apply_user;
        break;
      case "payment_type":
      case "zhibiao_date":
        params[key] = params_stand[key];
        break;
      case "is_recharge":
        params[key] = !!res.expense_group_recharge;
        break;
      /* ------------ */
      case "is_open_contract":
        params[key] = res.contract && res.contract.contract_nature === "open";
        break;
      case "expense_group_settlements":
        params[key] = (res.expense_group_settlements || []).map((item) => ({
          ...(item.contract_settlement || {}),
          appoint_payment_amount: (item.contract_settlement || {})
            .payment_amount,
          contract_settlement_id: item.contract_settlement_id,
          payment_amount: item.payment_amount,
        }));
        break;
      /* 项目分摊信息 */

      case "expenses":
        if (!res.expenses || !res.expenses.length) {
          params.expenses = [createFTinfor()];
        } else {
          params.expenses = res.expenses.map((item) => {
            const clone_item = {};
            const item_stand = createFTinfor();
            Object.keys(item_stand).forEach((item_key) => {
              if (item_key === "expense_teams") {
                if (!item.expense_teams || !item.expense_teams.length) {
                  clone_item.expense_teams = [createTeam()];
                } else {
                  clone_item.expense_teams = item.expense_teams;
                }
              } else if (item_key === "expense_spus") {
                if (!item.expense_spus || !item.expense_spus.length) {
                  clone_item.expense_spus = [createSpu()];
                } else {
                  clone_item.expense_spus = item.expense_spus;
                }
              } else {
                clone_item[item_key] = item[item_key];
              }
            });
            return clone_item;
          });
        }
        break;
      /* 需要区分外包兼职合同和非外包兼职合同 */
      case "have_paid":
        params[key] = res.contract && res.contract.have_paid;
        break;
      case "hetong_total_price":
        params[key] = res.contract && res.contract.total_price;
        break;
      case "sk_company_id":
        params[key] = res.company_id;
        break;
      case "verified_at":
        if (res.verified_at) {
          params[key] = moment(res[key]).format("YYYY-MM-DD");
        } else {
          params[key] = "";
        }
        break;
      case "expense_group_recharge":
        if (res[key]) {
          params[key] = Object.keys(params_stand[key]).reduce((t, _key) => {
            t[_key] = res[key][_key];
            return t;
          }, {});
        } else {
          params[key] = creatBcParams();
        }
        break;
      // case 'is_yzh_cbs':
      //     params[key] = false
      //     break
      case "is_cbs":
        params[key] = false;

        break;
      case "tfjc_type":
        if (res.placing_ads_records && res.placing_ads_records.length) {
          params.tfjc_type = 0;
        }
        if (res.placing_ads_vas_records && res.placing_ads_vas_records.length) {
          params.tfjc_type = 1;
        }
        break;
      case "contract_source":
        params.contract_source =
          res.contract && res.contract.id
            ? res.contract
            : res.outsource_contract;
        break;
      default:
        params[key] = res[key];
        break;
    }
  });
  return params;
}

export function getContractFkType(contract) {
  let str = "normal";
  if (!!contract.contract_recharge || contract.is_recharge) {
    str = "recharge";
  } else if (
    contract.contract_type &&
    ["stock"].includes(contract.contract_type.main_type)
  ) {
    str = "stock";
  }
  return str;
}
